import React from 'react';
import { Button } from '../ui/button';
import { Plus, CopyPlus, ArrowUp, ArrowDown } from 'lucide-react';

export const SlideThumbnails = ({
  slides, activeIdx, thumbs,
  switchSlide, addSlide, duplicateSlide, moveSlide, deleteSlide,
}) => (
  <div className="w-44 border-r bg-muted/10 flex flex-col shrink-0" data-testid="slide-panel">
    <div className="flex-1 overflow-y-auto p-2 space-y-2">
      {slides.map((slide, idx) => (
        <div
          key={slide.id}
          onClick={() => switchSlide(idx)}
          className={`group relative rounded-md border-2 cursor-pointer transition-all ${
            idx === activeIdx ? 'border-primary ring-1 ring-primary/30' : 'border-transparent hover:border-muted-foreground/30'
          }`}
          data-testid={`slide-thumb-${idx}`}
        >
          <div className="aspect-video bg-white dark:bg-neutral-800 rounded overflow-hidden">
            {thumbs[idx] ? (
              <img src={thumbs[idx]} alt={`Slide ${idx + 1}`} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-xs text-muted-foreground"></div>
            )}
          </div>
          <div className="text-[10px] text-center text-muted-foreground mt-0.5">{idx + 1}</div>
          {slides.length > 1 && (
            <button
              onClick={(e) => { e.stopPropagation(); deleteSlide(idx); }}
              className="absolute -top-1 -right-1 w-4 h-4 bg-destructive text-destructive-foreground rounded-full text-[10px] leading-none opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
              data-testid={`delete-slide-${idx}`}
            >
              x
            </button>
          )}
        </div>
      ))}
    </div>
    <div className="p-2 border-t space-y-1">
      <Button variant="outline" size="sm" className="w-full text-xs" onClick={addSlide} data-testid="add-slide-btn">
        <Plus className="w-3 h-3 mr-1" /> Add Slide
      </Button>
      <div className="flex gap-1">
        <Button variant="ghost" size="sm" className="flex-1 text-[10px] h-7" onClick={duplicateSlide} data-testid="duplicate-slide-btn" title="Duplicate Slide">
          <CopyPlus className="w-3 h-3 mr-0.5" /> Dup
        </Button>
        <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => moveSlide(-1)} disabled={activeIdx === 0} title="Move Up">
          <ArrowUp className="w-3 h-3" />
        </Button>
        <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => moveSlide(1)} disabled={activeIdx === slides.length - 1} title="Move Down">
          <ArrowDown className="w-3 h-3" />
        </Button>
      </div>
    </div>
  </div>
);
